import {
  createDefaultDescriptionPayload,
  defaultDescriptionsParams,
  updateDefaultDescriptionsParams,
} from '../../models/payload/defaultDescriptions';

import { ropoloRequest } from '../axios';

const getDefaultDescriptions = async (params: defaultDescriptionsParams) =>
  (await ropoloRequest.identityDefaultdescriptionList(params)).data;

const updateDefaultDescription = async (params: updateDefaultDescriptionsParams) =>
  (await ropoloRequest.identityDefaultdescriptionUpdate(params)).data;

const createDefaultDescriptionService = async (params: createDefaultDescriptionPayload) =>
  (await ropoloRequest.identityDefaultdescriptionCreate(params)).data;

const removeDefaultDescription = async (id: number) => (await ropoloRequest.identityDefaultdescriptionDelete(id)).data;

export { getDefaultDescriptions, updateDefaultDescription, createDefaultDescriptionService, removeDefaultDescription };
